import React from 'react';
import { LoadingIndicator } from './LoadingIndicator';
import styles from './LoadingOverlay.module.scss';

interface OverlayProps {
  isVisible: boolean;
}

export const LoadingOverlay = ({ isVisible }: OverlayProps) => {
  if (isVisible) {
    return (
      <div className={styles.loadingOverlay}>
        <div className={styles.wrapper}>
          <LoadingIndicator />
        </div>
      </div>
    );
  }
  return null;
};
